require('es6-promise').polyfill();
import 'url-search-params-polyfill';
import './assets/scss/style.scss';
import Vue from 'vue'
import router from './router/router'
import App from './App'
import {store} from './store/store'

Vue.config.productionTip = true

if(process.env.NODE_ENV !== 'development') {
    router.beforeEach((to, from, next) => {
        if (to.meta.sessionCheck === true) {
            store.dispatch('postApi', {
                'controller':'PCAuth',
                'action':'checkSession',
                'post':''
            })
            .then(response => {
                if(response.status===200&&response.data.protagonistId != undefined) {
                    window.location.href = 'index.php';
                }
                else {
                    next()
                }
            })
        }else {
            next()
        }
    });
}

new Vue({
    el: '#app',
    router: router,
    store: store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js